import { graphql } from '@apollo/client/react/hoc';
import { flowRight as compose } from 'lodash';

import ViewNotificationMutation from 'buyside/graphql/mutations/ViewNotification';
import UnviewNotificationMutation from 'buyside/graphql/mutations/UnviewNotification';
import ToggleHideNotificationMutation from 'buyside/graphql/mutations/ToggleHideNotification';

import NotificationIndexItem from 'buyside/components/presentation/NotificationsIndex/NotificationIndexItem/notificationIndexItem';

const withViewNotification = graphql(ViewNotificationMutation, {
  props: ({ mutate }) => ({
    handleViewNotification: notificationId => {
      return mutate({
        variables: { notificationId }
      });
    }
  })
});

const withUnviewNotification = graphql(UnviewNotificationMutation, {
  props: ({ mutate }) => ({
    handleUnviewNotification: notificationId => {
      return mutate({
        variables: { notificationId }
      });
    }
  })
});

const withToggleHide = graphql(ToggleHideNotificationMutation, {
  props: ({ mutate }) => ({
    handleToggleHidden: (notificationId, hidden) => {
      return mutate({
        variables: { notificationId, hidden }
      });
    }
  })
});

const NotificationIndexItemContainer = compose(
  withViewNotification,
  withUnviewNotification,
  withToggleHide
)(NotificationIndexItem);

export default NotificationIndexItemContainer;
